module.exports = __webpack_public_path__ + "img/gle-benz.3433f4f3.png";